import {
  React,
  useRef,
  memo,
  Radio,
  useState,
  Box,
  Select,
  DatePicker,
  DatePanel,
  FormControlLabel,
  FormControl,
  toast,
  Button,
  Dialog,
  useCallback,
  Switch,
  RadioGroup,
  RemoveCircleIcon,
  EditIcon,
} from "../../../Libraries/Post/AddNewPost/Child/LayoutFooter/index";

const options = [
  { label: "Monday", value: "Monday" },
  { label: "Tuesday", value: "Tuesday" },
  { label: "Wednesday", value: "Wednesday" },
  { label: "Thursday", value: "Thursday" },
  { label: "Friday", value: "Friday" },
  { label: "Saturday", value: "Saturday" },
  { label: "Sunday", value: "Sunday" },
];

const LayoutFooter = (props) => {
  const [layoutfooterdata, setlayoutfooterdata] = useState({
    opendialog: false,
    rowindex: undefined,
    isFooterScuduled: false,
    isStatus: false,
    opendialogforadd: false,
    opendialogforedit: false,
    selectedOption: [],
    selectedDate: [],
    values: [],
    eselectedDate: undefined,
    eselectedOption: undefined,
    estatusbar: undefined,
    estatus: undefined,
    eradiobuttonvalue: undefined,
  });

  // //this description ref will store the input value of side description while adding
  const desc = useRef();
  const edesc = useRef();

  //this function will change the value of radion buttons while adding
  const handleChangeRadioButtons = (event) => {
    props.handleChangeRadioButtonvalue(event.target.value);
    setlayoutfooterdata({
      ...layoutfooterdata,
      values: [],
      selectedOption: [],
      selectedDate: [],
    });
  };

  const handleChangeRadioButtonsedit = (event) => {
    setlayoutfooterdata({
      ...layoutfooterdata,
      values: [],
      selectedOption: [],
      selectedDate: [],
      eselectedDate: [],
      eradiobuttonvalue: event.target.value,
    });
  };

  //this function will handle the add dialog
  const opendialogforaddingrow = () => {
    setlayoutfooterdata({
      ...layoutfooterdata,
      opendialog: true,
      opendialogforadd: true,
      opendialogforedit: false,
    });
  };

  const handlesetSelectedOption = (e) => {
    setlayoutfooterdata({
      ...layoutfooterdata,
      selectedOption: e,
    });
  };

  const handleChangeeselectedOption = (e) => {
    setlayoutfooterdata({
      ...layoutfooterdata,
      eselectedOption: e,
    });
  };
  //this function will handle the edit dialog
  const opendialogforeditrow = (index) => {
    const editData = props.rowsData.filter((item, i) => i === index && item);
    if (editData.length === 1) {
      var match =
        editData[0].days !== "N/A" ? editData[0]?.days.split(",") : [];
      const result = match.map((value) => ({ label: value, value }));
      setlayoutfooterdata({
        ...layoutfooterdata,
        eselectedOption: result,
        estatusbar: editData[0].is_scheduled,
        estatus: editData[0].txt_status,
        eradiobuttonvalue: editData[0].date_wise_or_day_wise,
        values:
          editData[0].date_wise_or_day_wise === "Date wise"
            ? editData[0].date_wise_scheduled_date.split(",")
            : [],
        rowindex: index,
        opendialog: true,
        opendialogforedit: true,
        opendialogforadd: false,
      });
    } else {
      toast.error("Something went wrong");
    }
  };

  //this function will change the value of sidebar scudluding switch while adding
  const handleChange = (event) => {
    setlayoutfooterdata({
      ...layoutfooterdata,
      isFooterScuduled: event.target.checked,
      selectedOption: [],
      values: [],
    });
    props.handleChangeRadioButtonvalue("");
  };

  //this function will change the value of sidebar status while adding
  const handleChangeStatus = (event) => {
    setlayoutfooterdata({
      ...layoutfooterdata,
      isStatus: event.target.checked,
    });
  };

  //this function will change the value of sidebar scudlued while editing
  const handleChangescuduledswitch = (event) => {
    setlayoutfooterdata({
      ...layoutfooterdata,
      values: [],
      eselectedOption: [],
      selectedDate: [],
      eradiobuttonvalue: "",
      estatusbar: event.target.checked,
    });
  };

  //this function will change the value of sidebar status while editing
  const handleChangeestatus = (event) => {
    setlayoutfooterdata({
      ...layoutfooterdata,
      estatus: event.target.checked,
    });
  };

  //this function will change the value of sidebar status while adding
  const handleChangeDate = (v) => {
    const datesx = v.map((date) => date.format());
    setlayoutfooterdata({
      ...layoutfooterdata,
      values: v,
      selectedDate: datesx.toString(),
    });
  };

  //this function will change the value of sidebar status while editing
  const handleChangeDatee = (v) => {
    const datesx = v.map((date) => date.format());
    setlayoutfooterdata({
      ...layoutfooterdata,
      values: v,
      eselectedDate: datesx.toString(),
    });
  };
  //add
  const addTableRows = () => {
    if (
      desc.current.value === undefined ||
      desc.current.value === "undefined" ||
      desc.current.value === null ||
      desc.current.value === "null" ||
      desc.current.value === ""
    ) {
      toast.error("Please add the footer description");
    } else if (
      layoutfooterdata.isFooterScuduled &&
      props.data.radiobuttonvalue === "Day wise" &&
      layoutfooterdata.selectedOption.length === 0
    ) {
      toast.error("Please select the days");
    } else if (
      layoutfooterdata.isFooterScuduled &&
      props.data.radiobuttonvalue === "Date wise" &&
      layoutfooterdata.selectedDate.length === 0
    ) {
      toast.error("Please select the date");
    } else if (
      layoutfooterdata.isFooterScuduled &&
      props.data.radiobuttonvalue === ""
    ) {
      toast.error("Please choose the date/days");
    } else {
      const formatedscudlueddays = String(
        layoutfooterdata.selectedOption?.map((day) => day.value)
      );
      const rowsInput = {
        txt_footer_description: desc.current.value,
        txt_status: layoutfooterdata.isStatus,
        is_scheduled: layoutfooterdata.isFooterScuduled,
        days:
          layoutfooterdata.isFooterScuduled === true &&
          props.data.radiobuttonvalue === "Day wise"
            ? formatedscudlueddays
            : "N/A",
        date_wise_or_day_wise:
          layoutfooterdata.isFooterScuduled === true
            ? props.data.radiobuttonvalue
            : "N/A",
        date_wise_scheduled_date:
          layoutfooterdata.isFooterScuduled === true &&
          props.data.radiobuttonvalue === "Date wise"
            ? layoutfooterdata.selectedDate
            : "N/A",
      };
      props.setRowsData([...props.rowsData, rowsInput]);
      desc.current.value = "";
      setlayoutfooterdata({
        ...layoutfooterdata,
        isFooterScuduled: false,
        selectedOption: [],
        selectedDate: [],
        values: [],
        isStatus: false,
      });
    }
  };

  //delete
  const deleteTableRows = (index) => {
    const rows = [...props.rowsData];
    rows.splice(index, 1);
    props.setRowsData(rows);
  };

  //onDialoghide
  const hideDialog = useCallback(() => {
    setlayoutfooterdata({
      ...layoutfooterdata,
      opendialog: false,
      values: [],
      isFooterScuduled: false,
      isStatus: false,
    });
    props.handleChangeRadioButtonvalue("");
  }, [props, layoutfooterdata]);

  //this function will be called when user edit sidebar data
  const EditRowData = useCallback(() => {
    if (
      edesc.current.value === undefined ||
      edesc.current.value === "undefined" ||
      edesc.current.value === null ||
      edesc.current.value === "null" ||
      edesc.current.value === ""
    ) {
      toast.error("Sidebar description not to be empty");
    } else if (
      layoutfooterdata.estatusbar &&
      layoutfooterdata.eradiobuttonvalue === ""
    ) {
      toast.error("Please choose the date/days");
    } else if (
      layoutfooterdata.estatusbar &&
      layoutfooterdata.eradiobuttonvalue === "Day wise" &&
      layoutfooterdata.eselectedOption.length === 0
    ) {
      toast.error("Please select the Days");
    } else if (
      layoutfooterdata.estatusbar &&
      layoutfooterdata.eradiobuttonvalue === "Date wise" &&
      layoutfooterdata.eselectedDate.length === 0
    ) {
      toast.error("Please select the Dates");
    } else {
      const formatedscudlueddays = String(
        layoutfooterdata.eselectedOption?.map((day) => day.value)
      );
      const editData = props?.rowsData.map((item, index) =>
        index === layoutfooterdata.rowindex
          ? {
              ...item,
              txt_footer_description: edesc.current.value,
              txt_status: layoutfooterdata.estatus,
              is_scheduled: layoutfooterdata.estatusbar,
              days:
                layoutfooterdata.estatusbar === true &&
                layoutfooterdata.eradiobuttonvalue === "Day wise"
                  ? formatedscudlueddays
                  : "N/A",
              date_wise_or_day_wise:
                layoutfooterdata.estatusbar === true
                  ? layoutfooterdata.eradiobuttonvalue
                  : "N/A",
              date_wise_scheduled_date:
                layoutfooterdata.estatusbar === true &&
                layoutfooterdata.eradiobuttonvalue === "Date wise"
                  ? layoutfooterdata.eselectedDate
                  : "N/A",
            }
          : item
      );
      props.setRowsData(editData);
      hideDialog();
    }
  }, [props, layoutfooterdata, hideDialog]);

  const addsidebarfooter = (
    <React.Fragment>
      <Button variant="contained" onClick={addTableRows} className="capitalized fs-14 fw-bold">
        Add
      </Button>
    </React.Fragment>
  );

  const savesidebarfooter = (
    <React.Fragment>
      <Button variant="contained" onClick={EditRowData} className="capitalized fs-14 fw-bold">
        save
      </Button>
    </React.Fragment>
  );

  //SSBR Function
  const isValidIndex =
  Array.isArray(props.rowsData) &&
  Number.isInteger(layoutfooterdata.rowindex) &&
  layoutfooterdata.rowindex >= 0 &&
  layoutfooterdata.rowindex < props.rowsData.length;

const safeRow = isValidIndex ? props.rowsData[layoutfooterdata.rowindex] : null;

  return (
    <>
      <Box sx={{ flexGrow: 1, mb: 2, ml: 2, mr: 1 }}>
        <div className="sideBarDiv">
          <div id="labelDiv">
            <label id="sideHeadLabel">Footer post</label>
          </div>
          <div id="addBtnDiv">
            <div id="blueBtnSubDiv">
              <Button
                variant="primary"
                id="blueAddBtn"
                onClick={opendialogforaddingrow}
                className="capitalized fs-14 fw-bold"
              >
                Add
              </Button>
            </div>
          </div>
        </div>
        <div>
          <div className="shadow-4 rounded-1 overflow-hidden">
            <table className="table align-middle mb-0 bg-white">
              <thead className="bg-light">
                <tr>
                  <th
                    style={{
                      width: "20%",
                      alignItems: "center",
                      textAlign: "center",
                    }}
                  >
                    Description
                  </th>
                  <th
                    style={{
                      width: "20%",
                      alignItems: "center",
                      textAlign: "center",
                    }}
                  >
                    Schedule Status
                  </th>
                  <th
                    style={{
                      width: "20%",
                      alignItems: "center",
                      textAlign: "center",
                    }}
                  >
                    Status
                  </th>
                  <th
                    style={{
                      width: "20%",
                      alignItems: "center",
                      textAlign: "center",
                    }}
                  >
                    Actions
                  </th>
                </tr>
              </thead>
              <tbody>
                {props.rowsData &&
                  props.rowsData.map((row, index) => (
                    <tr key={index}>
                      <td
                        style={{
                          width: "25%",
                          alignItems: "center",
                          textAlign: "center",
                        }}
                      >
                        {row.txt_footer_description}
                      </td>
                      <td
                        style={{
                          width: "25%",
                          alignItems: "center",
                          textAlign: "center",
                        }}
                      >
                        <Switch
                          checked={row.is_scheduled}
                          inputProps={{ "aria-label": "controlled" }}
                        />
                      </td>

                      <td
                        style={{
                          width: "25%",
                          alignItems: "center",
                          textAlign: "center",
                        }}
                      >
                        <Switch
                          checked={row.txt_status}
                          inputProps={{ "aria-label": "controlled" }}
                        />
                      </td>

                      <td
                        style={{
                          display: "flex",
                          justifyContent: "center",
                          padding: "15px",
                        }}
                      >
                        <div>
                          <RemoveCircleIcon
                            onClick={() => deleteTableRows(index)}
                            style={{ marginRight: "10px" }}
                          />
                          <EditIcon
                            onClick={() => opendialogforeditrow(index)}
                          />
                        </div>
                      </td>
                    </tr>
                  ))}
              </tbody>
            </table>
          </div>
        </div>
        <Dialog
          visible={layoutfooterdata.opendialog}
          style={{ width: "500px" }}
          breakpoints={{ "960px": "75vw", "640px": "100vw" }}
          header={
            layoutfooterdata.opendialogforadd ? "Add Footer" : "Edit Footer"
          }
          modal
          footer={
            layoutfooterdata.opendialogforadd
              ? addsidebarfooter
              : savesidebarfooter
          }
          onHide={hideDialog}
        >
          {layoutfooterdata.opendialogforadd &&
          !layoutfooterdata.opendialogforedit ? (
            <>
              <div className="row">
                <div className="col">
                  <label htmlFor="exampleFormControlTextarea1">
                    Description
                  </label>
                  <textarea
                    ref={desc}
                    className="form-control"
                    id="exampleFormControlTextarea1"
                    rows="3"
                  ></textarea>
                </div>
              </div>
              <div className="row">
                <div className="col">
                  <div className="form-group">
                    <label htmlFor="formControlRange">Footer Schedule</label>
                    <Switch
                      checked={layoutfooterdata.isFooterScuduled}
                      onChange={handleChange}
                      inputProps={{ "aria-label": "controlled" }}
                    />
                  </div>
                </div>
              </div>
              {layoutfooterdata.isFooterScuduled && (
                <>
                  <div className="row">
                    <div className="col">
                      <FormControl>
                        <RadioGroup
                          row
                          aria-labelledby="demo-row-radio-buttons-group"
                          name="demo-row-radio-buttons-group"
                          value={props.data.radiobuttonvalue}
                          onChange={handleChangeRadioButtons}
                        >
                          <FormControlLabel
                            value="Day wise"
                            control={<Radio />}
                            label="Day wise"
                          />
                          <FormControlLabel
                            value="Date wise"
                            control={<Radio />}
                            label="Date wise"
                          />
                        </RadioGroup>
                      </FormControl>
                    </div>
                  </div>
                  {props.data.radiobuttonvalue === "Day wise" ? (
                    <div className="row">
                      <div className="col">
                        <div className="form-group">
                          <label htmlFor="formControlRange">
                            Schedule Days
                          </label>
                          <Select
                            options={options}
                            onChange={handlesetSelectedOption}
                            isMulti="true"
                            isClearable={true}
                            name="scudleddays"
                            placeholder="Select Days"
                            menuPortalTarget={document.body}
                            menuPosition="fixed"
                            styles={{
                              menuPortal: (provided) => ({
                                ...provided,
                                zIndex: 9999,
                              }),
                              menu: (provided) => ({
                                ...provided,
                                zIndex: 9999,
                              }),
                            }}
                          />
                        </div>
                      </div>
                    </div>
                  ) : props.data.radiobuttonvalue === "Date wise" ? (
                    <div className="row">
                      <div className="col">
                        <DatePicker
                          multiple
                          sort
                          calendarPosition="bottom-center"
                          value={layoutfooterdata.values}
                          onChange={handleChangeDate}
                          plugins={[
                            <DatePanel key={layoutfooterdata.values} />,
                          ]}
                        />
                      </div>
                    </div>
                  ) : null}
                </>
              )}
              <div className="row">
                <div className="col ">
                  <div className="form-group">
                    <label htmlFor="formControlRange">Status</label>
                    <Switch
                      checked={layoutfooterdata.isStatus}
                      onChange={handleChangeStatus}
                      inputProps={{ "aria-label": "controlled" }}
                    />
                  </div>
                </div>
              </div>
            </>
          ) : !layoutfooterdata.opendialogforadd &&
            layoutfooterdata.opendialogforedit ? (
            <>
              <div className="row">
                <div className="col">
                  <label htmlFor="exampleFormControlTextarea1">
                    Edit Description
                  </label>
                  <textarea
                    className="form-control"
                    name="description"
                    ref={edesc}
                    //SSBR
                    // use This
                    defaultValue={safeRow?.txt_footer_description || ""}
                    // defaultValue={
                    //   props.rowsData[layoutfooterdata.rowindex]
                    //     ?.txt_footer_description
                    // }
                    id="exampleFormControlTextarea1"
                    rows="3"
                  ></textarea>
                </div>
              </div>
              <div className="row">
                <div className="col">
                  <div className="form-group">
                    <label htmlFor="formControlRange">
                      Edit Footer Schedule
                    </label>
                    <Switch
                      checked={layoutfooterdata.estatusbar}
                      onChange={handleChangescuduledswitch}
                      inputProps={{ "aria-label": "controlled" }}
                    />
                  </div>
                </div>
              </div>
              {layoutfooterdata.estatusbar && (
                <>
                  <div className="row">
                    <div className="col">
                      <FormControl>
                        <RadioGroup
                          row
                          aria-labelledby="demo-row-radio-buttons-group"
                          name="demo-row-radio-buttons-group"
                          value={layoutfooterdata.eradiobuttonvalue}
                          onChange={handleChangeRadioButtonsedit}
                        >
                          <FormControlLabel
                            value="Day wise"
                            control={<Radio />}
                            label="Day wise"
                          />
                          <FormControlLabel
                            value="Date wise"
                            control={<Radio />}
                            label="Date wise"
                          />
                        </RadioGroup>
                      </FormControl>
                    </div>
                  </div>
                  {layoutfooterdata.eradiobuttonvalue === "Day wise" ? (
                    <div className="row">
                      <div className="col">
                        <div className="form-group">
                          <label htmlFor="formControlRange">
                            Edit Schedule Days
                          </label>
                          <Select
                            options={options}
                            name="scudlueddays"
                            defaultValue={layoutfooterdata.eselectedOption}
                            onChange={handleChangeeselectedOption}
                            isMulti="true"
                            isClearable={true}
                            placeholder="Select Days"
                            menuPortalTarget={document.body}
                            menuPosition="fixed"
                            styles={{
                              menuPortal: (provided) => ({
                                ...provided,
                                zIndex: 9999,
                              }),
                              menu: (provided) => ({
                                ...provided,
                                zIndex: 9999,
                              }),
                            }}
                          />
                        </div>
                      </div>
                    </div>
                  ) : layoutfooterdata.eradiobuttonvalue === "Date wise" ? (
                    <div className="row">
                      <div className="col">
                        <DatePicker
                          multiple
                          sort
                          calendarPosition="bottom-center"
                          value={layoutfooterdata.values}
                          onChange={handleChangeDatee}
                          plugins={[
                            <DatePanel key={layoutfooterdata.values} />,
                          ]}
                        />
                      </div>
                    </div>
                  ) : null}
                </>
              )}
              <div className="row">
                <div className="col ">
                  <div className="form-group">
                    <label htmlFor="formControlRange">Edit Status</label>
                    <Switch
                      checked={layoutfooterdata.estatus}
                      onChange={handleChangeestatus}
                      inputProps={{ "aria-label": "controlled" }}
                    />
                  </div>
                </div>
              </div>
            </>
          ) : null}
        </Dialog>
      </Box>
    </>
  );
};

export default memo(LayoutFooter);
